import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "搜索", to: "/search" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const solid = !isHome || scrolled;

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    if (!kw) return;
    navigate(`/search?keyword=${encodeURIComponent(kw)}`);
    setKeyword("");
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        solid
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-[72px] flex items-center gap-4 md:gap-8">
        <Link to="/" className="flex items-center gap-2 shrink-0 group">
          <span className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-black text-lg md:text-xl tracking-tight">
            91
          </span>
          <span className={`font-black text-xl md:text-2xl tracking-tight ${solid ? "text-foreground-950" : "text-white"}`}>
            91<span className="text-primary-500">n</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive
                    ? "text-primary-500 bg-primary-100/60"
                    : solid
                    ? "text-foreground-700 hover:text-primary-500 hover:bg-background-100"
                    : "text-white/85 hover:text-white hover:bg-white/10"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="hidden lg:flex flex-1 max-w-md ml-auto">
          <div className="relative w-full">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索电影、电视剧、演员…"
              className="w-full h-10 pl-9 pr-3 rounded-md text-sm bg-background-100 border border-background-200 text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:bg-background-50 transition-colors"
            />
          </div>
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="菜单"
          className={`md:hidden ml-auto w-10 h-10 flex items-center justify-center rounded-md ${
            solid ? "text-foreground-900 bg-background-100" : "text-white bg-white/15"
          }`}
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-4 animate-fade-in">
          <form onSubmit={handleSearch} className="mb-3">
            <div className="relative w-full">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索电影、电视剧…"
                className="w-full h-10 pl-9 pr-3 rounded-md text-sm bg-background-100 border border-background-200 text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400"
              />
            </div>
          </form>
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-3 py-2.5 rounded-md text-sm font-medium ${
                    isActive ? "text-primary-500 bg-primary-100/60" : "text-foreground-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}